import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import { createStore } from 'vuex'

const store = createStore({
    state() {
        return {
            firebaseURL: 'https://firestore.googleapis.com/v1/projects/blog-8e606/databases/(default)/documents/posts/'
        }
    },
});

createApp(App).use(router).use(store).mount('#app')
